import { render, staticRenderFns } from "./FormGroupRG.vue?vue&type=template&id=23fa4e27&scoped=true"
import script from "./FormGroupRG.vue?vue&type=script&lang=js"
export * from "./FormGroupRG.vue?vue&type=script&lang=js"
import style0 from "./FormGroupRG.vue?vue&type=style&index=0&id=23fa4e27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fa4e27",
  null
  
)

export default component.exports